/**
 * 🗂️ 商談 Hub (v3.3 IA 刷新)
 *
 * 統合対象:
 *   - sales.deals (商談ボード; 内部に board / inbox 内部タブを保持)
 *   - system.stale-deals (段階解禁) — 旧システム管理から商談 Hub へ移動
 *   - system.deals-trash (ゴミ箱) — 同上
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { DealsBoardPage } from './DealsBoardPage';
import { StaleDealsPage } from '@/pages/admin/StaleDealsPage';
import { DealsTrashPage } from '@/pages/admin/DealsTrashPage';


const TABS: TabSpec[] = [
  { tabKey: 'board', label: '商談ボード', featureId: 'sales.deals',        render: () => <DealsBoardPage /> },
  { tabKey: 'stale', label: '段階解禁',   featureId: 'system.stale-deals', render: () => <StaleDealsPage /> },
  { tabKey: 'trash', label: 'ゴミ箱',     featureId: 'system.deals-trash', render: () => <DealsTrashPage /> },
];

export function DealsHubPage() {
  return <HubTabs tabs={TABS} defaultTab="board" />;
}
